"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _this = void 0;
var _default = exports["default"] = function _default(delay, callback) {
  var timeoutID;
  var wrapper = function wrapper() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var promise = new Promise(function (resolve) {
      var exec = function exec() {
        callback.apply(_this, args);
        resolve();
      };
      if (timeoutID) {
        clearTimeout(timeoutID);
      }
      timeoutID = setTimeout(exec, delay);
    });
    return promise;
  };
  return {
    init: wrapper,
    cancel: function cancel() {
      return clearTimeout(timeoutID);
    }
  };
};
//# sourceMappingURL=getDebouncedMethod.js.map